export default __webpack_public_path__ + "static/media/bg4.cc279921.png";